var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content-box"},[_c('div',{staticClass:"banner-box"},[_c('bannerLeftEl'),_c('bannerCenterEl'),_c('bannerRightEl')],1),_c('configZone1El')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }